module.exports = __webpack_public_path__ + "img/symbol_4.f9a3d5f6.png";